import { MutationTree } from 'vuex';
import { EVideoLinkMutation } from '@/video/link/store/video-link.constants';
import { IVideoLinkState } from '@/video/link/store/video-link.types';
import { IVideo } from '@/types/Video';

export const mutations: MutationTree<IVideoLinkState> = {
  [EVideoLinkMutation.TogglePreview](state: IVideoLinkState, show: boolean) {
    state.showPreview = show;
  },
  [EVideoLinkMutation.SetVideoURL](state: IVideoLinkState, url: string) {
    state.url = url;
  },
  [EVideoLinkMutation.SetFeedbackMessage](state: IVideoLinkState, message: string) {
    state.feedbackMessage = message;
  },
  [EVideoLinkMutation.SetVideoTitle](state: IVideoLinkState, title: string) {
    state.title = title;
  },
  [EVideoLinkMutation.SetLoading](state: IVideoLinkState, loading: boolean) {
    state.loading = loading;
  },
  [EVideoLinkMutation.ResetState](state: IVideoLinkState, defaultState: IVideoLinkState) {
    state.createdVideo = defaultState.createdVideo;
    state.loading = defaultState.loading;
    state.url = defaultState.url;
    state.feedbackMessage = defaultState.feedbackMessage;
    state.showPreview = defaultState.showPreview;
    state.title = defaultState.title;
  },
  [EVideoLinkMutation.SetCreatedVideo](state: IVideoLinkState, video: IVideo) {
    state.createdVideo = video;
  },
};
